module.exports = __webpack_public_path__ + "static/media/mail.a98d2332.png";